module.exports = [{
      plugin: require('/Volumes/X9 Pro/code-projects/fairfest/fairfest-gatsby/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
